 const customInputs = {
};
import { setUp } from "/opt/build/repo/node_modules/@mechanic-design/core/src/input-set-up.js";
const [inputsDefs, customComponents, interactiveInputs, inputErrors] = setUp(customInputs);
export {inputsDefs, customComponents, interactiveInputs, inputErrors};
